import { VHCRecordCheckBrakeItemInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type SaveBreakItemInput = {
  logId: number;
  requestBody?: VHCRecordCheckBrakeItemInput;
};

export const useSaveBreakItemMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecordsItemsBrakes, SaveBreakItemInput>
) =>
  useMutationWithNotifications(
    ({ logId, requestBody }: SaveBreakItemInput) => VhcRecordLogService.postVhcRecordsItemsBrakes(logId, requestBody),
    options
  );
